/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { User } from "./User";
import * as t from "io-ts";

// required attributes
const UserResponseR = t.interface({});

// optional attributes
const UserResponseO = t.partial({
  data: User
});

export const UserResponse = t.intersection(
  [UserResponseR, UserResponseO],
  "UserResponse"
);

export type UserResponse = t.TypeOf<typeof UserResponse>;
